import React from "react";
import { ArrowUpRight } from "lucide-react";

export default function FloatingCTA() {
    const onClick = (e) => {
        e.preventDefault();
        const target = document.getElementById("hero-form");
        if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "center" });
            const firstInput = target.querySelector("input, select, button");
            if (firstInput) {
                setTimeout(() => firstInput.focus({ preventScroll: true }), 700);
            }
        } else {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <button
            type="button"
            onClick={onClick}
            data-testid="floating-apply-now"
            aria-label="Apply Now"
            className="group fixed right-5 md:right-8 top-1/2 -translate-y-1/2 z-50 inline-flex items-center gap-2 px-5 md:px-6 py-3.5 rounded-full font-bold tracking-wide uppercase text-xs md:text-sm shadow-floating transition-all duration-300 hover:translate-y-[-52%] animate-float-pulse"
            style={{ background: "#ffc004", color: "#2e326b" }}
        >
            <span>Apply Now</span>
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </button>
    );
}
